import { createSlice } from "@reduxjs/toolkit";
import { logoutUser } from "../actions/account";
import { getDashboardWidgets } from "../actions/dashboardWidgets";

const initialState = {
  widgets: [],
  isLoadingGetDashboardWidgets: false,
  errorGetDashboardWidgets: "",
};

const dashboardWidgetsSlice = createSlice({
  name: "dashboardWidgets",
  initialState,
  extraReducers: {
    [getDashboardWidgets.pending]: (state) => {
      state.isLoadingGetDashboardWidgets = true;
      state.errorGetDashboardWidgets = "";
    },
    [getDashboardWidgets.fulfilled]: (state, action) => {
      state.isLoadingGetDashboardWidgets = false;
      state.widgets = action?.payload?.data || [];
      state.errorGetDashboardWidgets = "";
    },
    [getDashboardWidgets.rejected]: (state, action) => {
      state.isLoadingGetDashboardWidgets = false;
      state.errorGetDashboardWidgets =
        action?.payload?.message || action?.error?.message || "Failed to load widgets.";
    },
    [logoutUser.fulfilled]: () => {
      return initialState;
    },
    [logoutUser.rejected]: () => {
      return initialState;
    },
  },
});

export const getDashboardWidgetsData = (state) =>
  state?.dashboardWidgets?.widgets;
export const getIsLoadingDashboardWidgets = (state) =>
  state?.dashboardWidgets?.isLoadingGetDashboardWidgets;
export const getDashboardWidgetsError = (state) =>
  state?.dashboardWidgets?.errorGetDashboardWidgets;

export default dashboardWidgetsSlice;
